import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../constants/dataAids';
import { updateMembership } from '../actions/BookingForm';
import { trackMetric } from '../utils/trackMetric';
import { BOOKING_FORM_MEMBERSHIP_DISCLAIMER_CHECKBOX_CLICK } from '../constants/metrics';

export default class Disclaimer extends Component {
  onCheckboxClick = e => {
    updateMembership(e.target.checked);
    trackMetric(BOOKING_FORM_MEMBERSHIP_DISCLAIMER_CHECKBOX_CLICK);
  };

  render() {
    const { disclaimer, staticContent, styles, requiresConsent } = this.props;
    const {
      Block,
      Text,
      Details,
      Input: { Checkbox }
    } = UX2.Element;

    return (
      <Block tag='label' style={ styles.sectionDisclaimer }>
        <Block style={{ marginTop: requiresConsent ? 'none' : 'xxsmall' }}>
          <Checkbox
            tag='input'
            type='checkbox'
            data-aid={ dataAids.BOOKING_FORM_DISCLAIMER_CHECKBOX }
            checked={ disclaimer }
            onChange={ this.onCheckboxClick }
          />
        </Block>
        <Block data-aid={ dataAids.BOOKING_FORM_DISCLAIMER_TEXT }>
          <Text style={ styles.sectionDisclaimerText1 }>{ staticContent.disclaimerCreateAccount }</Text>
          { !requiresConsent && (
            <Details style={ styles.sectionDisclaimerText2 }>
              { staticContent.disclaimerRewardsEmail }
            </Details>
          ) }
        </Block>
      </Block>
    );
  }
}

Disclaimer.propTypes = {
  styles: PropTypes.object,
  disclaimer: PropTypes.bool,
  staticContent: PropTypes.object.isRequired,
  requiresConsent: PropTypes.bool.isRequired
};
